import { put, takeLatest, call } from 'redux-saga/effects';
import ApiCaller from '../ApiCaller';

const callAPI = (payload) => {
  return ApiCaller('/v1/admin/tag', 'post', payload);
};
export default function* watchRequest() {
  yield takeLatest('NEW_TAG', function* performAction(action) {
    yield put({ type: 'NEW_TAG_INITIATED' });
    try {
      const data = yield call(callAPI.bind(this, action.payload));
      yield put({ type: 'NEW_TAG_SUCCESS', payload: data });
    } catch (error) {
      yield put({ type: 'NEW_TAG_FAILED', payload: error });
    }
  });
}